import { RootStateOrAny } from 'react-redux';

// OTP
export const selectOtpEnabled = (state: RootStateOrAny): boolean =>
  Boolean(state.user.get('otpEnabled'));
